<template>
  <section class="package_screen__wrapper"
           :class="emptyPage && ['d-flex', 'justify-content-center',
           'align-items-center', 'flex-column']"
  >
    <div class="banner_container">
      <div
          v-if="bannerText"
          class="alert alert-secondary alert-dismissible fade show"
          role="alert"
      >
        <div class="banner-text">
          <p v-html="bannerHtml"/>
        </div>
        <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
    <packages-nodes @no-passes="showEmptyPage"/>
    <h2 v-if="emptyPage"> {{ $t('no passes') }}</h2>
  </section>
</template>
<script>
import {mapGetters} from 'vuex';
import {mapCacheActions} from 'vuex-cache';
import {GET_CHANNEL_PAGE} from '@/store/actionTypes';
import {GET_PAGE_ID_FOR_URL, HAS_PASSES_TO_SHOW} from '@/store/getterTypes';
import {PASSES_TOP_BANNER} from '@/pages';
import PackagesNodes from '@/components/base-components/Packages/Nodes.vue';
import Vue from 'vue';

export default {
  name: 'PackagesScreen',
  components: {
    PackagesNodes,
  },
  data() {
    return {
      bannerContent: null,
      emptyPage: false,
    };
  },
  methods: {
    ...mapCacheActions({
      getPage: GET_CHANNEL_PAGE,
    }),
    getBannerText() {
      this.bannerPageId && this.getPage(this.bannerPageId).then(({data}) => {
        this.bannerContent = data;
      }).catch(() => (this.bannerText = null));
    },
    showEmptyPage({hasPasses}) {
      this.emptyPage = !hasPasses;
    },
  },
  computed: {
    ...mapGetters({
      pageId: GET_PAGE_ID_FOR_URL,
      passesExist: HAS_PASSES_TO_SHOW,
    }),
    bannerHtml() {
      return this.convertEditorJsonToHtml(this.bannerText);
    },
    bannerText() {
      return this.bannerContent?.content_lang?.[Vue.i18n.locale()] || this.bannerContent?.content;
    },
    bannerPageId() {
      return this.pageId(PASSES_TOP_BANNER.path);
    },
  },
  mounted() {
    this.getBannerText();
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/css/mixins";
.package_screen__wrapper{
  padding: 1rem var(--padding-y-mobile);
}
.banner_container {
  max-width: 71.25rem;
  margin: 0 auto;
  padding: 1.125rem 0;
}

.banner-text {
  font-size: 0.875rem;
  text-transform: none;
  text-align: left;
  font-weight: normal;
  font-style: normal;
}
</style>
